import { addModal } from 'weblite-web-modal-viewer'
// component
import { ContextMenu } from '$comp/_app/components/chat/components/body/components/context-menu/context-menu'

const COMPONENT_ID = 'contextMenu'

interface Prop {
  roomId: string
  iid: number
  xAxis: number
  yAxis: number
}

export const showContextMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: ContextMenu },
}
